export default {
    id: null,
    title: null,
    address: null,
    serial: null,
    subStartDate: null,
    subPeriod: null,
    studentLicences: null,
    teacherLicences : null,
    defaultLanguage : null,
    country: {
        id: 0,
        title: null,
    },
    createdAt: null,
    courses: [],
    list: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/school/state.js